if (!customElements.get('bfcm-tab-products')) {
  class BfcmTabProducts extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('.bfcm-tab-products__tab-list');
      this.containerList = this.querySelectorAll('.bfcm-tab-products__products-container');

      this.initTabEvent();
    }

    initTabEvent() {
      this.tabList.addEventListener('click', (e) => {
        const target = e.target;
        if (e.target.tagName == 'LI') {
          const tab = target.getAttribute('data-tab');
          this.tabList.querySelector('.active')?.classList.remove('active');
          target.classList.add('active');
          for (const container of this.containerList) {
            const containerForTab = container.getAttribute('data-tab');
            if (containerForTab == tab) {
              container.classList.add('active');
            } else {
              container.classList.remove('active');
            }
          }
          // Scroll into view
          const container = this.tabList;
          const containerLeft = container.scrollLeft;
          const containerWidth = container.clientWidth;
          const itemLeft = target.offsetLeft - container.offsetLeft;
          const itemWidth = target.offsetWidth;
          // console.log(containerLeft, containerWidth, itemLeft, itemWidth);
          if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
            container.scroll({
              left: itemLeft,
              behavior: 'smooth'
            });
          }
        }
      });
    }
  }

  customElements.define('bfcm-tab-products', BfcmTabProducts);
}


if (!customElements.get('bfcm-tab-products-swiper')) {
  class BfcmTabProductsSwiper extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 2);
      this._swiperContainer = this;

      const isMobile = `(max-width: 768px)`;
      const isMobileMQL = window.matchMedia(isMobile);

      isMobileMQL.addEventListener('change', (event) => {
        if (!event.matches) {
          this.createSlider();
        } else if (this.mySwiper) {
          this.destroySwiper();
        }
      });
      if (!isMobileMQL.matches) this.createSlider();
    }

    createSlider() {
      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }
      });
    }

    destroySwiper() {
      this._swiperInstance.destroy();
    }
  }

  customElements.define('bfcm-tab-products-swiper', BfcmTabProductsSwiper);
}